import virtualOutputComponentProvider from "../../../../../../../utils/virtualOutputComponentProvider";
import Ripple from "../../../../../../dumb/Ripple";
import {Link} from "../../../../../../../router";
import * as links from "../../../../../../../constants/links";
import RowA from "../../../../../../dumb/Row/A";
import ColA from "../../../../../../dumb/Col/A";
import {
  DisplayAmountAdmin,
  DisplayDataAdmin,
  DisplayDateTimeAdmin,
  DisplayIdAdmin
} from "../../../../../../dumb/DisplayData";
import Tooltip from "../../../../../../dumb/Tooltip/A";
import upperFirst from "mn-utils/upperFirst";
import ColA2 from "../../../../../../dumb/Col/A2";
import noop from "mn-utils/noop";
import openDeleteWindow from "../../utils/openDeleteWindow";
import TrashIcon from "../../../../../../icons/Trash";
import WrapperWithLoading from "../../../../../../dumb/WrapperWithLoading";
import ButtonD from "../../../../../../dumb/Button/D";
import RefreshIcon from "@material-ui/icons/Refresh";
import RowB from "../../../../../../dumb/Row/B";
import ColB from "../../../../../../dumb/Col/B";
import ColB2 from "../../../../../../dumb/Col/B2";
import ButtonUp from "../../../../../../dumb/Button/Up";
import React from "react";
import {
  apiAdminPayoutVertoInitiatedList,
  apiAdminPayoutVertoInitiatedTestList
} from "../../../../../../../api/admin/payout/verto";
import ResendMoneyIcon from "../../../../../../icons/ResendMoney";
import {openPopupSend} from "../../utils/openPopupSend";


const STATUS_CLASS_MAP = {
  initiated: 'i',
  pending: 'p',
  completed: 'c',
  failed: 'f',
};

const vertoTableCtor = (api) => virtualOutputComponentProvider({
  rowHeight: 70,
  request: api,
  wrapper(render, setState, self) {
    function Item({data}) {
      const id = data.id || '';
      const shortID = data.short_id || '';
      const withdrawalDate = data.created_at || null;

      const merchantName = data.merchant_name || '';
      const merchantEmail = data.merchant_email || '';
      const currency = data.fiat_code;
      const amount = data.amount;
      const status = data.status;
      // const sendDisables = ['completed', 'failed', 'canceled'].includes(status);
      const sendDisables = false;
      const deleteDisables = status !== 'initiated';

      return (
        <Ripple
          component={Link}
          href={`${links.LINK_ADMIN_PAYOUT_VERTO_GROUP_INFO}/${id}`}
          className="olN tdN dB w cF dn bgF.03:h"
        >
          <RowA className="f12">
            <ColA className="wmin155 fx1">
              {shortID ? (
                <>
                  <DisplayIdAdmin>{shortID}</DisplayIdAdmin>
                  <DisplayIdAdmin className="wsNW wmax fhaS c717275 mt3 f12 fw4">
                    {id}
                  </DisplayIdAdmin>
                </>
              ) : (
                <DisplayIdAdmin>{id}</DisplayIdAdmin>
              )}
            </ColA>
            <ColA className="wmin147">
              <DisplayDateTimeAdmin
                date={withdrawalDate}
              />
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayDataAdmin>{merchantName}</DisplayDataAdmin>
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayDataAdmin>{merchantEmail}</DisplayDataAdmin>
            </ColA>
            <ColA className="wmin130 fx1">
              <DisplayAmountAdmin
                amount={amount}
                symbol={currency}
                type="fiat"
              />
            </ColA>
            <ColA className="wmin130 fx1">
              <Tooltip>
                <span className={'(cA294FF).i (cFFBF43).p (c2CE889).c (cEE4F4F).f) ' + STATUS_CLASS_MAP[status]}>
                  {upperFirst(status)}
                </span>
              </Tooltip>
            </ColA>
            <ColA2 className="w50">
              <Tooltip title="Send" disabledCopy>
                <Ripple
                  className={
                    `w42 h42 p7 r7 (bgc0.25):h:not[.disabled] (o15).disabled`
                    + (sendDisables ? ' disabled' : '')
                  }
                  onClick={() => openPopupSend(data, self.update)}
                  disabled={sendDisables}
                >
                  <ResendMoneyIcon />
                </Ripple>
              </Tooltip>
            </ColA2>
            <ColA2 className="w50">
              <Tooltip title="Delete" disabledCopy>
                <Ripple
                  className="w42 h42 p7 r7 (bgc0.25):h:not[.disabled] o15.disabled"
                  onClick={deleteDisables
                    ? noop
                    : () => openDeleteWindow(data, self.update)
                  }
                  disabled={deleteDisables}
                >
                  <TrashIcon className="w25 h25"/>
                </Ripple>
              </Tooltip>
            </ColA2>
          </RowA>
        </Ripple>);
    }

    return (state) => {
      return (
        <>
          <div className="h75 layoutRow jcFE aiC">
            <WrapperWithLoading
              loading={state.loading}
            >
              <ButtonD
                className="wmin100"
                onClick={self.update}
              >
                <RefreshIcon/>
                <div className="pl15">Refresh</div>
              </ButtonD>
            </WrapperWithLoading>
          </div>
          <div className="rlv h100vh-240 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin980 rlv h">
                <RowB className="f14">
                  <ColB className="wmin155 fx1">ID</ColB>
                  <ColB className="wmin147">Withdrawal Date</ColB>
                  <ColB className="wmin130 fx1">Name</ColB>
                  <ColB className="wmin130 fx1">Email</ColB>
                  <ColB className="wmin130 fx1">Amount</ColB>
                  <ColB className="wmin130 fx1">Status</ColB>
                  <ColB2 className="w50"/>
                  <ColB2 className="w50"/>
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </>
      );
    };
  },
}, {});

module.exports = {
  VertoTableInitiated: vertoTableCtor(apiAdminPayoutVertoInitiatedList),
  VertoTableInitiatedTests: vertoTableCtor(apiAdminPayoutVertoInitiatedTestList),
}
